import * as React from 'react';
import {useCallback, useEffect, useState} from "react";
import {useAppDispatch} from "../../app/hooks";
import {logoutAsync} from "./sessionSlice";
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export const Logout = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const [logoutState, setLogoutState] = useState(null)
    const logout = useCallback(async () => {
        const newState: any = await dispatch(logoutAsync());
        setLogoutState(newState)
    }, [])

    useEffect(() => {
        logout().catch(console.error)
    }, [logout]);

    useEffect(() => {
        if (logoutState) {
            let loginPath = "/?reason=disconnect";
            const redirectPath = searchParams.get("redirect");
            if (redirectPath) {
              loginPath += `&redirect=${redirectPath}`;
            }
            window.location.href = loginPath;
        }
    }, [logoutState, searchParams])
    return (
        <p>{t('loggingOut')}</p>
    );
}